/**
 * @author vishwadeep.kapoor
 * @Date: 2019-02-05 15:58:29
 * @Last Modified by: chandu
 * @Last Modified time: 2019-06-25 15:45:04
 */

import React from 'react';
import { Upload, Button, Icon } from 'antd';
import { string, func, bool, shape, number } from 'prop-types';
import StyledUpload from './StyledUpload';
import { utils } from '../../devUtils';

function Fileupload(props) {
  const { fileName,
    onHandleChange,
    type,
    submitBulkUpload,
    showUploadIcon,
    isShowSubmit,
    isLoadingStatus,
    label,
    iconType,
    accept,
    fileSize,
    isFileValidation,
    ...otherProps
  } = props;
  const upload_props = {
    multiple: false,
    type: 'select',
    showUploadList: false,
    action: null,
    beforeUpload: (file) => utils.fileValidation(file, { fileSize, fileType: accept, isFileValidation }),
    accept,
    onChange: (fileObj) => onHandleChange(type, fileObj, otherProps),
  };
  return (
    <StyledUpload>
      {showUploadIcon ? <span className="upload-text cursor">&nbsp;{fileName}</span> : ''}
      {Object.keys(iconType).length ?
        <Upload {...upload_props}>
          <img className="cursor" src={iconType.URL} alt={iconType.ALT} />
          <strong className="cursor">{ label }</strong>
        </Upload> :
        <Upload {...upload_props}>
          {showUploadIcon ?
            <Button>
              <Icon type="upload" /> {label}
            </Button> : <strong className="cursor">{ label }&nbsp;{fileName}</strong>}
        </Upload>
      }
      {isShowSubmit ?
        <Button
          onClick={submitBulkUpload}
          disabled={!fileName}
          loading={isLoadingStatus}
        >Submit
        </Button> : ''}
    </StyledUpload>
  );
}

Fileupload.propTypes = {
  showUploadIcon: bool,
  isShowSubmit: bool,
  isLoadingStatus: bool,
  isFileValidation: bool,
  fileName: string,
  label: string,
  type: string,
  accept: string,
  fileSize: number,
  iconType: shape({}),
  onHandleChange: func.isRequired,
  submitBulkUpload: func,

};

Fileupload.defaultProps = {
  fileName: '',
  type: 'fileType',
  isShowSubmit: false,
  isFileValidation: false,
  submitBulkUpload: () => { },
  isLoadingStatus: false,
  label: 'Browse',
  showUploadIcon: true,
  iconType: {},
  fileSize: 104857600, // 104857600 bytes == 100MB
  accept: '',
};
export default Fileupload;




// WEBPACK FOOTER //
// client/components/Upload/index.js